import React from 'react';
import { Link } from 'react-router-dom';

// 
export default function Post({ title, thumbUrl, alt, date, btnText, href, socialShare, tags }) {
  return (
    <div className={`cs_post cs_style_1`}>
      <Link to={href} className="cs_post_thumb cs_view_mouse">
        <img src={thumbUrl} alt={alt || title} />
      </Link>
      <div className="cs_post_info">
        <div>
          <div className="cs_post_meta">{date}</div>
          <h2 className="cs_post_title cs_semibold cs_fs_32">
            <Link to={href}>{title}</Link>
          </h2>
          {tags && (
            <div className="post-tags">
              {tags.map((tag) => (
                <span key={tag} className="post-tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
        {btnText && (
          <div className="cs_heading_color cs_medium">
            <Link to={href} className="cs_post_btn">
              {btnText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
